import React from 'react';
import { PrimaryButton } from 'DesignSystem/Buttons';

export default class LandingPagePhotoToPDFModal extends React.PureComponent {

  static createPDF() {
    window.Upload.photoToPDF.createPDF();
    window._track('create-pdf-from-image', 'edit-pdf page');
  }

  render() {
    return (
      <div id="photoToPDF" className="hidden centered photoToPDF">
        <div className="image-upload-heading-container">
          <p className="image-upload-text">Rearrange, Add, Delete Images</p>
          <div className="image-upload-buttons-container">
            <div id="addImages-btn" className="addImages-btn ds-btn-secondary sm dark">
              Add Images
              <input
                type="file"
                accept={
                  `application/msword,
                  application/vnd.openxmlformats-officedocument.wordprocessingml.document
                  application/pdf,
                  image/*`
                }
                id="selectPhotos"
                name="files[]"
                multiple
              />
            </div>
            <PrimaryButton onClick={LandingPagePhotoToPDFModal.createPDF} size="sm">
              <span>Create PDF</span>
            </PrimaryButton>
          </div>
        </div>
        <div className="photo-wrapper">
          <ul id="photoList" />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src-react/LandingPagePhotoToPDFModal/index.jsx